import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  canchas: [],
  fetchCanchasLoading: false,
  fetchCanchasError: null,

  cancha: {},
  fetchCanchaLoading: false,
  fetchCanchaError: null,

  addCanchaLoading: false,
  addCanchaError: null,

  updateCanchaLoading: false,
  updateCanchaError: null,

  verifyCanchaLoading: false
};

export const canchasSlice = createSlice({
  name: 'CANCHAS',
  initialState,
  reducers: {
    fetchCanchasStart: state => {
      state.fetchCanchasLoading = true;
      state.fetchCanchasError = null;
    },
    fetchCanchasSuccess: (state, action) => {
      state.fetchCanchasLoading = false;
      state.canchas = action.payload;
    },
    fetchCanchasError: (state, action) => {
      state.fetchCanchasLoading = false;
      state.fetchCanchasError = action.payload;
    },

    fetchCanchaStart: state => {
      state.fetchCanchaLoading = true;
      state.fetchCanchaError = null;
    },
    fetchCanchaSuccess: (state, action) => {
      state.fetchCanchaLoading = false;
      state.cancha = action.payload;
    },
    fetchCanchaError: (state, action) => {
      state.fetchCanchaLoading = false;
      state.fetchCanchaError = action.payload;
    },

    addCanchaStart: state => {
      state.addCanchaLoading = true;
      state.addCanchaError = null;
    },
    addCanchaSuccess: (state, action) => {
      state.addCanchaLoading = false;
      state.canchas.unshift(action.payload);
    },
    addCanchaError: (state, action) => {
      state.addCanchaLoading = false;
      state.addCanchaError = action.payload;
    },

    updateCanchaStart: state => {
      state.updateCanchaLoading = true;
      state.updateCanchaError = null;
    },
    updateCanchaSuccess: (state, action) => {
      state.updateCanchaLoading = false;
      state.cancha = action.payload;
      const newArray = state.canchas.map(cancha => {
        if (cancha.id === action.payload.id) return action.payload;
        return cancha;
      });
      state.canchas = newArray;
    },
    updateCanchaError: (state, action) => {
      state.updateCanchaLoading = false;
      state.updateCanchaError = action.payload;
    },

    verifyCanchaStart: state => {
      state.verifyCanchaLoading = true;
    },
    verifyCanchaSuccess: state => {
      state.verifyCanchaLoading = false;
    },
    verifyCanchaError: state => {
      state.verifyCanchaLoading = false;
    }
  }
});

export const {
  fetchCanchasStart,
  fetchCanchasSuccess,
  fetchCanchasError,
  fetchCanchaStart,
  fetchCanchaSuccess,
  fetchCanchaError,
  addCanchaStart,
  addCanchaSuccess,
  addCanchaError,
  updateCanchaStart,
  updateCanchaSuccess,
  updateCanchaError,
  verifyCanchaStart,
  verifyCanchaSuccess,
  verifyCanchaError
} = canchasSlice.actions;

export default canchasSlice.reducer;
